export default "__VITE_ASSET__CIfsCTBu__"